import { call, put, takeLeading } from "redux-saga/effects";
import { setAuthToken } from "../../actions/auth";
import {
  requirementActions, setRequirementTechnical
} from "../../actions/Requirement";
import { APIResponse } from "../../../utility/commonTypes";
import { getRequirementTechnicalAsync, updateRequirementTechnicalAsync } from "../../../api/common";

function* RequirementTechnical(action: any) {
  const { payload, callback } = action;
  try {
    let res: APIResponse = yield call(
     
        updateRequirementTechnicalAsync,
      payload
    );
    console.log(res.data);
   
 if (res?.status === 200) {
      yield put(setRequirementTechnical({ ...res.data },function(){}));
      callback(res?.data);
    } else {
      callback(false);
    }
  } catch (error) {
    callback(false);
  }
}
function* GetRequirementTechnical(action: any) {
  const { payload, callback } = action;
  try {
    let res: APIResponse = yield call(getRequirementTechnicalAsync, payload);
    console.log(res.data);
    if (res?.status === 200) {
      yield put(setRequirementTechnical({ ...res.data },function(){}));
      callback(res?.data);
    } else {
      callback(false);
    }
  } catch (error) {
    callback(false);
  }
}
export function* watchRequirementTechnical() {
  yield takeLeading(requirementActions.GET_REQUIREMENT_TECHNICAL, GetRequirementTechnical);
  yield takeLeading(requirementActions.UPDATE_REQUIREMENT_TECHNICAL, RequirementTechnical);
}
